<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-xl-12">
                            <h4 class="card-title">Logstack Cost by Service</h4>
                            <h3>Total Cost for the last 20 days: {{ this.logstack_costs_total }}</h3>
                            <chart-card :key='logstack_costs_data' :chart-data="logstack_costs_data.data"
                                        :chart-options="logstack_costs_data.options"
                                        :responsive-options="logstack_costs_data.responsiveOptions"
                                        chart-type="Bar"
                            >
                                <template slot="footer">
                                    <div class="legend">
                                        <span v-for="(service,i) in logstack_costs_data.service_name">
                                          <i class="fa fa-circle" :style='{color: colors[i]}'></i>{{ service }}
                                        </span>
                                        <!-- <i class="fa fa-circle text-warning"></i> AWS Commitment (no VAT) -->
                                    </div>
                                </template>
                            </chart-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ChartCard from 'src/components/Cards/ChartCard.vue'
    import StatsCard from 'src/components/Cards/StatsCard.vue'
    import LTable from 'src/components/Table.vue'
    import axios from 'axios'
    import { colors, formatMoney, formatSimple, chart_base } from 'src/globalVariables'
    import { setInterval } from 'timers';


    Number.prototype.pad = function(size) {
        let s = String(this);
        while (s.length < (size || 2)) {s = "0" + s;}
        return s;
    }

    export default {
        components: {
            LTable,
            ChartCard,
            StatsCard
        },
        async created() {
            this.accessToken = await this.$auth.getAccessToken()
            this.loadData();
            let vm = this;
            setInterval(function(){
                vm.loadData();
            },vm.refresh_minutes*60*1000);
        },
        methods: {
            loadData: function(){
                let today = new Date();
                this.last_update = today.getHours().pad(2) + ":" + today.getMinutes().pad(2) + ":" + today.getSeconds().pad(2);
                console.log('refreshing...');
                axios
                    .get('logstack/costs?access_token=' + this.accessToken)
                    .then(response => (this.logstack_costs = response.data));
            },
            refresh_logstack: function() {
                let [labels, series, service_name] = [[], [], []];

                if (this.logstack_costs){
                    for (let date in this.logstack_costs['results']) {
                        labels.push(date.substring(5));
                        this.logstack_costs['results'][date].forEach(function(v,i){
                            let entry = Object.entries(v);
                            if (service_name.includes(entry[0][0]) == false) {
                                service_name.push(entry[0][0])
                            }

                            if (typeof series[i] == 'undefined') {
                                series[i] = [];
                            }
                            series[i].push(entry[0][1]);
                        });
                    }

                    this.logstack_costs_total = formatMoney.format(this.logstack_costs['total']);
                    this.logstack_costs_data = {
                        'service_name': service_name,
                        'data': {
                            'labels': labels,
                            'series': series
                        },
                        'options': {
                            'stackBars': true,
                            'seriesBarDistance': 20,
                            'seriesBarWidth': 30,
                            'axisX': {
                                'showGrid': true,
                                'showLabel': true
                            },
                            'height': '245px',
                            'chartPadding': {
                                'right': 50,
                                'left': 50,
                                'bottom': 10,
                            },
                            'tooltip': {
                                'tooltipFnc': function(meta, value) {
                                    return (value)
                                },

                                tooltipOffset: {
                                    x: 10,
                                    y: 70
                                },
                                'appendToBody': false,
                                'transformTooltipTextFnc': function(value) {
                                    return formatMoney.format(value)
                                }
                            },
                        },
                        'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
                    }
                }
            }
        },
        watch: {
            logstack_costs:function(){
                this.refresh_logstack()
            },
        },
        computed: {

        },
        data () {
            return {
                refresh_minutes: 30,
                last_update: '',
                colors: colors,
                logstack_costs: {},
                logstack_costs_total: 0,
                logstack_costs_data: {},
                editTooltip: 'Edit Task',
                deleteTooltip: 'Remove',
                accessToken: '',
            }
        }
    }
</script>
<style>
    h4.btn {
        background-color: #343a40;
        border-color: #343a40;
        color: #FFFFFF;
    }
</style>
